import "./Login.scss";

import validator from "validator";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { Navigate, useNavigate } from "react-router-dom";

import queryString from "query-string";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import api from "../../services/api";
import logo from "../../assets/images/logo_lingo.svg";
import ButtonMB from "../../components/Buttons/Button";
import { encryptValue } from "../../utils/fieldEncrypt";
import imgOndas1 from "../../assets/images/login/img_ondas/1.png";
import imgOndas2 from "../../assets/images/login/img_ondas/2.png";
import imgOndas3 from "../../assets/images/login/img_ondas/3.png";
import imgOndasBg from "../../assets/images/login/img_ondas/bg.jpg";
import { changePassword, verifyToken } from "../../store/middleware";

const bgImgArr = [imgOndas1, imgOndas2, imgOndas3];

function ForgetPass() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [success] = useState(false);
  const [user, setUser] = useState({});
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState([]);
  const [password, setPassword] = useState("");
  const [leftImage, setleftImage] = useState("");
  const [dialogMsg, setDialogMsg] = useState("");
  const [goToLogin, setGoToLogin] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toggleShowPassword = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const toggleShowConfirmPassword = (e) => {
    e.preventDefault();
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleForm = async (e) => {
    e.preventDefault();

    var patt =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&[\]{},.;<>:/~^´`\-_()"])[A-Za-z\d@$!%*#?&[\]{},.;<>:/~^´`\-_()"]{6,20}$/g;

    if (!patt.test(password)) {
      setOpen(true);
      setDialogMsg(t("PASS_INVALID_MESSAGE"));
      setDialogTitle(t("INVALID_FORM_TITLE"));
      return false;
    } else if (password !== confirmPassword) {
      setOpen(true);
      setDialogMsg(t("PASS_NOTEQUAL_MESSAGE"));
      setDialogTitle(t("ERROR"));
      return false;
    } else {
      setErrors([
        !validator.isEmpty(password) ? !(password === confirmPassword) : validator.isEmpty(password),
        !validator.isEmpty(confirmPassword) ? !(password === confirmPassword) : validator.isEmpty(confirmPassword),
      ]);

      if (!errors[0] && !errors[1]) {
        let objSend = {
          id: user.id,
          userPassword: {
            password: encryptValue(password),
          },
        };

        await dispatch(changePassword(JSON.stringify(objSend), queryString.parse(location?.search).token))
          .then(() => {
            setOpen(true);
            setDialogMsg(t("PASSWORD_CHANGE"));
            setDialogTitle(t("SUCCESS_MESSAGE"));
            setGoToLogin(true);
          })
          .catch((e) => {
            console.log("teste error", e.message);
            let errMsg = e.data.error.message !== undefined ? e.data.error.message : e.data.error.message;
            setOpen(true);
            setDialogMsg(errMsg);
            setDialogTitle(t("ERROR"));
          });
      } else {
        setOpen(true);
        setDialogMsg(t("PASSWORD_NOT_MATCH"));
        setDialogTitle(t("ERROR"));
      }
    }
  };

  useEffect(() => {
    setleftImage(bgImgArr[Math.round(Math.random() * 2)]);

    let forgetToken = queryString.parse(window.location?.search).token;

    if (forgetToken !== undefined) {
      sessionStorage.removeItem("@lingo");
      dispatch(verifyToken(forgetToken))
        .then((res) => {
          setUser(res);
          api.get(`/token/create/${res.id}`).then((res) => console.log("new token ", res));
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line
  }, []);

  if (success) return <Navigate to="/" />;

  return (
    <div className="containerBox">
      <div className="content-left" style={{ backgroundImage: `url(${imgOndasBg})` }}>
        <img src={logo} className="logo-top" alt="logo" />
        <img src={leftImage} className="img-random" alt="logo" />
      </div>

      <div className="content-right">
        <div className="forget-pass form-holder">
          <div className="forget-header-holder">
            <div className="forget-header">
              <span>{t("CHANGE_PASSWORD_TITLE")}</span>
            </div>
            <div className="red-line" />
          </div>
          <div className="form-holder">
            <form>
              <label htmlFor="password">
                {t("PASSWORD")}
                <span style={{ fontSize: "0.9em" }}>{}</span>
              </label>
              <div className="input-lingo-div-password">
                <input
                  tabIndex={2}
                  name="password"
                  value={password}
                  required={errors[1]}
                  style={{ width: "90%" }}
                  placeholder={t("PASSWORD")}
                  className="input-lingo-password"
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button onClick={(e) => toggleShowPassword(e)} className="input-lingo-button-password">
                  {showPassword ? <IoMdEyeOff size={18} /> : <IoMdEye size={18} />}
                </button>
              </div>
              <label htmlFor="confirmPassword">
                {t("PASSWORD_CONFIRM")}
                <span style={{ fontSize: "0.9em" }}>{}</span>
              </label>
              <div className="input-lingo-div-password">
                <input
                  tabIndex={2}
                  required={errors[1]}
                  name="confirmPassword"
                  value={confirmPassword}
                  style={{ width: "90%" }}
                  className="input-lingo-password"
                  placeholder={t("PASSWORD_CONFIRM")}
                  type={showConfirmPassword ? "text" : "password"}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button onClick={(e) => toggleShowConfirmPassword(e)} className="input-lingo-button-password">
                  {showConfirmPassword ? <IoMdEyeOff size={18} /> : <IoMdEye size={18} />}
                </button>
              </div>
            </form>

            <div className="holder-buttons">
              <ButtonMB title={t("BTN_SEND")} clickAction={handleForm} />
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={open}
        keepMounted
        className="boxModal"
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" className="boxModal">
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" className="boxModal">
            {dialogMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="boxModal">
          {goToLogin && (
            <Button onClick={() => navigate("/login")} color="primary">
              {t("BTN_CLOSE")}
            </Button>
          )}

          {!goToLogin && (
            <Button onClick={() => setOpen(false)} color="primary">
              {t("BTN_CLOSE")}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ForgetPass;
